import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as HelpResourcesFeature from './help-resources.reducer';
import { HelpResourcesEffects } from './help-resources.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(HelpResourcesFeature.feature.name, HelpResourcesFeature.feature.reducer),
        EffectsModule.forFeature([HelpResourcesEffects]),
    ],
})
export class SharedStateHelpResourcesModule {}
